import {Navigate, Route, Routes, Outlet} from 'react-router-dom'
import {PageTitle} from '@/_metronic/layout/core'
import {useParams} from 'react-router-dom'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import {ProductProvider} from './ProductContext'
import {Header} from './components/Header'
import Suppliers from './components/Suppliers'
import Reports from './components/Reports'
import {ProductForm} from './components/forms/ProductForm'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}, {
  title: 'Products',
  path: '/p2c/product/catalog',
}])


const ViewWrapper = () => {
  const {id} = useParams()

  if (!id) {
    return (<>No product id</>)
  }

  return (
    <ProductProvider productId={id}>
      <Routes>
        <Route
          element={
            <>
              <Header/>
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={Breadcrumbs}>Overview</PageTitle>
                <ProductForm />
              </>
            }
          />
          <Route
            path='suppliers'
            element={
              <>
                <PageTitle breadcrumbs={Breadcrumbs}>Suppliers</PageTitle>
                <Suppliers />
              </>
            }
          />
          <Route
            path='reports'
            element={
              <>
                <PageTitle breadcrumbs={Breadcrumbs}>Reports</PageTitle>
                <Reports />
              </>
            }
          />
          <Route index element={<Navigate to={`/product/${id}/overview`} />} />
        </Route>
      </Routes>
    </ProductProvider>
  )
}

export default ViewWrapper
